<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    userIds: number[]
    maxVisibleUsers?: number
    userImageClasses?: string
  }>(),
  {
    maxVisibleUsers: 3
  }
)

const users = computed(() => props.userIds.slice(0, props.maxVisibleUsers).map((id) => useUser(id)))
</script>

<template>
  <div class="tw-flex">
    <RelationshipUserImage
      v-for="user in users"
      :key="user.value?.id"
      :user="user.value ?? undefined"
      thumb
      class="tw-rounded-full tw-object-cover first:tw-ml-0"
      :class="props.userImageClasses"
    />

    <div
      v-if="props.userIds.length > props.maxVisibleUsers"
      class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-full tw-bg-white/80 tw-text-sm tw-font-bold tw-backdrop-blur"
      :class="props.userImageClasses"
    >
      <span>+{{ props.userIds.length - props.maxVisibleUsers }}</span>
    </div>
  </div>
</template>
